export default __webpack_public_path__ + "static/media/aj7.4076562e.png";